import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    isSSR: false,
    isLoading: false,
    isFetched: false,
    average: null,
    total: null,
    list: []
};

export const fetchCustomerReviews = (state = INITIAL_STATE) => {
    return { ...state, isLoading: true };
};

export const fetchCustomerReviewsSuccess = (state = INITIAL_STATE, {
    list, average, total }) => {
    return {
        ...state,
        isLoading: false,
        isFetched: true,
        list,
        average,
        total
    };
};

export const fetchCustomerReviewsFailure = (state = INITIAL_STATE) => {
    return { ...state, isLoading: false, isFetched: true, list: [] };
};

export const setIsSSR = (state = INITIAL_STATE, { isSSR }) => {
    return { ...state, isSSR};
};

export const HANDLERS = {
    [Types.FETCH_REVIEWS]: fetchCustomerReviews,
    [Types.FETCH_REVIEWS_SUCCESS]: fetchCustomerReviewsSuccess,
    [Types.FETCH_REVIEWS_FAILURE]: fetchCustomerReviewsFailure,
    [Types.SET_IS_SSR]: setIsSSR
};

export default createReducer(INITIAL_STATE, HANDLERS);
